/**
 * Submit the mounted Stripe card form from OUTSIDE it.
 *
 * The wizard's footer button lives in `SubscriptionWizardDialog`, several components above the
 * `<form>` it needs to submit, and a native `type="submit" form={id}` submitter is not usable here:
 * the same footer node is reused across the Configure → Payment transition, and a native submitter
 * reads its attributes AFTER the click has already advanced the step.
 *
 * The id is declared on `components/StripeCardForm.tsx`'s `<form>` — the form the wizard renders
 * via `dialogs/wizard/WizardStepConfirmation`.
 *
 * Extracted from a wizard-local `StripeCardForm.tsx` when that file was removed: its 1,186-line
 * component was only reachable through `PaymentSection`, behind a `showPayment` prop that was
 * permanently false (and has since been deleted outright), but these six lines were live. The
 * component is preserved on `feature/jessica/sub-ui-cost-summary-parked`.
 */
export const STRIPE_FORM_ID = 'stripe-payment-form';

export function submitStripeForm(): void {
  const form = document.getElementById(STRIPE_FORM_ID);
  if (form instanceof HTMLFormElement) form.requestSubmit();
}
